import { FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getContribLegge59Group = (form: FormGroup): FormGroup => {
    return getGroup(form, formPaths.contributoLegge59);
};

export const getContribLegge59Control = (form: FormGroup, path: string) => {
    return getControl(form, `${formPaths.contributoLegge59}.${path}`);
};

export const contribLegge59CkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath: string = formPaths.contributoLegge59,
    suppCondition = true,
    errorStatus?: string,
    errorMessage?: string
): void => {
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition, errorStatus, errorMessage);
};

export const buildContrib59Name = (name: string, isFirstYear: boolean) => {
    const suffix = isFirstYear ? 'Anno1' : '';
    return `${name}${suffix}`;
};
